import { render, staticRenderFns } from "./LawyerCard.vue?vue&type=template&id=62e31d4c&"
import script from "./LawyerCard.vue?vue&type=script&lang=ts&"
export * from "./LawyerCard.vue?vue&type=script&lang=ts&"
import style0 from "./LawyerCard.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports